import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import store from './state/store';
import { Provider } from 'react-redux';


let root = document.getElementById('tziroi-root');
let clientId = root.getAttribute('data-clientId');
let productId = root.getAttribute('data-productId');

ReactDOM.render((
  <Provider store={store}>
    <App clientId={clientId} productId={productId} />
  </Provider>  
), root);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js